export const modalReducerActions = { SHOW: 'show', HIDE: 'hide' };

export const modalReducer = (state, { type, payload: { modalId, ...payload } = {} }) => {
  switch (type) {
    case modalReducerActions.SHOW:
      return { ...state, modalId, ...payload };
    case modalReducerActions.HIDE:
      return { ...state, modalId: null };
    default:
      throw new Error('unrecognized action "${type}"');
  }
};
